module.exports = __webpack_public_path__ + "static/media/expand-icon.2b44f106.svg";